module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "clearfix",
    attrs: {
      "id": "visitRepair"
    }
  }, [_c('el-col', {
    staticClass: "clearfix searthPart"
  }, [_c('div', {
    staticClass: "clearfix container"
  }, [_c('p', {
    staticClass: "headerT fl",
    staticStyle: {
      "width": "80px",
      "margin-top": "0"
    }
  }, [_vm._v("工单信息")]), _vm._v(" "), (_vm.orderInfoForm.adminStatus == '20' || _vm.orderInfoForm.adminStatus == '04') ? _c('el-button', {
    staticClass: "fl",
    staticStyle: {
      "margin": "-5px 0 0 0px"
    },
    attrs: {
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v(_vm._s(_vm._f("sysCodeFileter")(_vm.orderInfoForm.adminStatus, 'admin_status')))]) : _c('el-button', {
    staticClass: "fl",
    staticStyle: {
      "margin": "-5px 0 0 0px"
    },
    attrs: {
      "size": "small",
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm._f("sysCodeFileter")(_vm.orderInfoForm.adminStatus, 'admin_status')))]), _vm._v(" "), (_vm.orderInfoForm.adminStatus == '04') ? _c('span', {
    staticClass: "fl",
    staticStyle: {
      "font-size": "14px",
      "margin-left": "10px"
    }
  }, [_vm._v("(挂起原因：" + _vm._s(_vm._f("sysCodeFileter")(_vm.orderInfoForm.handUpReason, 'hand_up_reason')) + ")")]) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.adminStatus == '20') ? _c('span', {
    staticClass: "fl",
    staticStyle: {
      "font-size": "14px",
      "margin-left": "10px"
    }
  }, [_vm._v("(取消原因：" + _vm._s(_vm._f("sysCodeFileter")(_vm.orderInfoForm.cancelReason, 'order_cancel_reason')) + " " + _vm._s(_vm.orderInfoForm.cancelDesc) + ")")]) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.maintenanceResult) ? _c('el-button', {
    staticClass: "fl",
    staticStyle: {
      "margin": "-5px 0 0 10px"
    },
    attrs: {
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v(_vm._s(_vm._f("sysCodeFileter")(_vm.orderInfoForm.maintenanceResult, 'maintenance_result')))]) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.maintenanceResult == '3') ? _c('span', {
    staticClass: "fl",
    staticStyle: {
      "font-size": "14px",
      "margin-left": "10px"
    }
  }, [_vm._v("(失败原因：" + _vm._s(_vm._f("sysCodeFileter")(_vm.orderInfoForm.repairFailureReason, 'maintance_fail_reason')) + " " + _vm._s(_vm.orderInfoForm.repairFailureDesc) + ")")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-star-off fl",
    class: {
      'StarOn': _vm.orderInfoForm.isTag == 1
    },
    staticStyle: {
      "font-size": "20px",
      "margin-left": "20px",
      "margin-right": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.setOrderTagOpe(_vm.orderInfoForm, _vm.orderInfoForm.isTag)
      }
    }
  }), _vm._v(" "), (_vm.orderInfoForm.attribute4 != null) ? _c('a', {
    attrs: {
      "href": ("https://m4.allscs.cn/n4web/detailInfo?id=" + (_vm.orderInfoForm.attribute4) + "&orderNo=" + (_vm.orderInfoForm.orderNo)),
      "download": "",
      "target": "_blank"
    }
  }, [_vm._v("查询维服")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.addMaterials) ? _c('el-button', {
    staticClass: "wuliao",
    staticStyle: {
      "margin": "-5px 0 0 0px"
    },
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addMaterials()
      }
    }
  }, [_vm._v("添加物料")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formSearch",
    attrs: {
      "inline": true,
      "model": _vm.formSearch
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": "小码"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请添加小码"
    },
    model: {
      value: (_vm.formSearch.smallCode),
      callback: function($$v) {
        _vm.$set(_vm.formSearch, "smallCode", $$v)
      },
      expression: "formSearch.smallCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("添加")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "label": "物料编码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "code",
      "label": "序列号（小码）"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteRow(scope.$index, _vm.tableData)
            }
          }
        }, [_vm._v("移除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confimAddMaterial
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "orderInfoForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.orderInfoForm,
      "label-width": "80px",
      "label-position": _vm.labelPosition
    }
  }, [_c('ul', {
    staticClass: "item-content"
  }, [_c('li', [_c('el-form-item', {
    attrs: {
      "label": "工单编号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "orderNo", $$v)
      },
      expression: "orderInfoForm.orderNo"
    }
  })], 1), _vm._v(" "), (_vm.orderInfoForm.originalOrderNo != null && _vm.orderInfoForm.originalOrderNo != '') ? _c('el-form-item', {
    attrs: {
      "label": "原始订单"
    }
  }, [_c('div', {
    staticClass: "fl",
    staticStyle: {
      "width": "85%",
      "background-color": "#f5f7fa",
      "border-color": "#e4e7ed",
      "color": "#3399FF",
      "cursor": "pointer",
      "border-radius": "4px",
      "border": "1px solid #dcdfe6",
      "padding-left": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.gotoOrigin(_vm.orderInfoForm)
      }
    }
  }, [_vm._v(_vm._s(_vm.orderInfoForm.originalOrderNo))])]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "工单类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择工单类型"
    },
    model: {
      value: (_vm.orderInfoForm.serviceType),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "serviceType", $$v)
      },
      expression: "orderInfoForm.serviceType"
    }
  }, _vm._l((_vm.orderTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "渠道来源",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择渠道来源",
      "disabled": !_vm.basicsAuth.change_order_source
    },
    model: {
      value: (_vm.orderInfoForm.orderIdentifier),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "orderIdentifier", $$v)
      },
      expression: "orderInfoForm.orderIdentifier"
    }
  }, _vm._l((_vm.sourceForList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "渠道类型",
      "prop": "orderIdentifier"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true,
      "filterable": "",
      "placeholder": "请选择渠道类型"
    },
    model: {
      value: (_vm.orderInfoForm.channelType),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "channelType", $$v)
      },
      expression: "orderInfoForm.channelType"
    }
  }, _vm._l((_vm.channelTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "bookTime"
  }, [_c('el-form-item', {
    attrs: {
      "label": "预约时间",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "31%",
      "font-size": "14px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.orderInfoForm.jOrderServiceEntity.onsiteDate),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm.jOrderServiceEntity, "onsiteDate", $$v)
      },
      expression: "orderInfoForm.jOrderServiceEntity.onsiteDate"
    }
  }), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "31%",
      "font-size": "14px"
    },
    attrs: {
      "placeholder": "起始时间",
      "picker-options": {
        start: '9:00',
        step: '01:00',
        end: '22:00'
      }
    },
    model: {
      value: (_vm.orderInfoForm.jOrderServiceEntity.onsiteTimeStart),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm.jOrderServiceEntity, "onsiteTimeStart", $$v)
      },
      expression: "orderInfoForm.jOrderServiceEntity.onsiteTimeStart"
    }
  }), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "31%",
      "font-size": "14px"
    },
    attrs: {
      "placeholder": "结束时间",
      "picker-options": {
        start: '9:00',
        step: '01:00',
        end: '22:00',
        minTime: _vm.orderInfoForm.jOrderServiceEntity.onsiteTimeStart
      }
    },
    model: {
      value: (_vm.orderInfoForm.jOrderServiceEntity.onsiteTimeEnd),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm.jOrderServiceEntity, "onsiteTimeEnd", $$v)
      },
      expression: "orderInfoForm.jOrderServiceEntity.onsiteTimeEnd"
    }
  })], 1)], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "item-content"
  }, [_c('li', [_c('el-form-item', {
    attrs: {
      "label": "客户姓名",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名（不超过30字）",
      "maxlength": 30
    },
    model: {
      value: (_vm.orderInfoForm.clientBasicInformation.customerName),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm.clientBasicInformation, "customerName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.clientBasicInformation.customerName"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "onKeypress": "return (/[\\d]/.test(String.fromCharCode(event.keyCode)))",
      "maxlength": 20
    },
    model: {
      value: (_vm.orderInfoForm.clientBasicInformation.telephoneNo),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm.clientBasicInformation, "telephoneNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.clientBasicInformation.telephoneNo"
    }
  })], 1)], 1), _vm._v(" "), (_vm.orderInfoForm.serviceType != 'DD' && _vm.orderInfoForm.serviceType != 'DS') ? _c('li', {
    staticClass: "location"
  }, [_c('el-form-item', {
    staticClass: "clearfix",
    attrs: {
      "label": "地址",
      "required": ""
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "15%",
      "float": "left"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "prop": "provinceId",
      "placeholder": "省"
    },
    on: {
      "change": _vm.choseProvince
    },
    model: {
      value: (_vm.provinceId),
      callback: function($$v) {
        _vm.provinceId = $$v
      },
      expression: "provinceId"
    }
  }, _vm._l((_vm.provinceList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "15%",
      "float": "left"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "value-key": "id",
      "placeholder": "市"
    },
    on: {
      "change": _vm.choseCity
    },
    model: {
      value: (_vm.cityId),
      callback: function($$v) {
        _vm.cityId = $$v
      },
      expression: "cityId"
    }
  }, _vm._l((_vm.cityList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "15%",
      "float": "left"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "value-key": "id",
      "placeholder": "区"
    },
    on: {
      "change": _vm.choseCounty
    },
    model: {
      value: (_vm.countyId),
      callback: function($$v) {
        _vm.countyId = $$v
      },
      expression: "countyId"
    }
  }, _vm._l((_vm.countyList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "15%",
      "float": "left"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "value-key": "id",
      "placeholder": "街道"
    },
    on: {
      "change": _vm.choseStreet
    },
    model: {
      value: (_vm.streetId),
      callback: function($$v) {
        _vm.streetId = $$v
      },
      expression: "streetId"
    }
  }, _vm._l((_vm.streetList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "40%",
      "float": "left"
    },
    attrs: {
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "94%"
    },
    attrs: {
      "maxlength": 200,
      "placeholder": "请输入详细地址（不超过200字）"
    },
    model: {
      value: (_vm.orderInfoForm.clientBasicInformation.address),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm.clientBasicInformation, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.clientBasicInformation.address"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.serviceType == 'DD' || _vm.orderInfoForm.serviceType == 'DS') ? _c('li', [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "门店",
      "required": "",
      "label-width": "50px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择门店"
    },
    on: {
      "change": _vm.selectShop
    },
    model: {
      value: (_vm.orderInfoForm.jOrderServiceEntity.shopId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm.jOrderServiceEntity, "shopId", $$v)
      },
      expression: "orderInfoForm.jOrderServiceEntity.shopId"
    }
  }, _vm._l((_vm.shopDataList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.orderInfoForm.serviceType == 'DD' || _vm.orderInfoForm.serviceType == 'DS') && _vm.orderTypeStorage == '2' && _vm.orderInfoForm.adminStatus != '01') ? _c('li', [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "工程师",
      "label-width": "70px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择门店工程师"
    },
    model: {
      value: (_vm.orderInfoForm.engineerId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "engineerId", $$v)
      },
      expression: "orderInfoForm.engineerId"
    }
  }, _vm._l((_vm.engineerDataList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "item-content"
  }, [_c('li', {
    staticClass: "memo"
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注信息"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": 400,
      "type": "text",
      "placeholder": "请输入备注信息（不超过400字）"
    },
    model: {
      value: (_vm.orderInfoForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.remark"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.orderInfoForm.orderCardInfo) ? _c('div', {
    staticClass: "dashLine"
  }) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.orderCardInfo) ? _c('div', {
    staticClass: "card-info"
  }, [_c('div', {
    staticClass: "card-item"
  }, [_c('div', {
    staticClass: "card-item-title"
  }, [_vm._v("卡号: ")]), _vm._v(" "), _c('div', {
    staticClass: "card-item-content"
  }, [_vm._v(_vm._s(_vm.orderInfoForm.orderCardInfo.cardNo))])]), _vm._v(" "), _c('div', {
    staticClass: "card-item"
  }, [_c('div', {
    staticClass: "card-item-title"
  }, [_vm._v("卡密: ")]), _vm._v(" "), _c('div', {
    staticClass: "card-item-content"
  }, [_vm._v(_vm._s(_vm.orderInfoForm.orderCardInfo.cardPwd))])]), _vm._v(" "), _c('div', {
    staticClass: "card-item"
  }, [_c('div', {
    staticClass: "card-item-title"
  }, [_vm._v("说明: ")]), _vm._v(" "), _c('div', {
    staticClass: "card-item-content"
  }, [_vm._v(_vm._s(_vm.orderInfoForm.orderCardInfo.memo))])])]) : _vm._e(), _vm._v(" "), (_vm.isDianShangBanDan) ? _c('div', {
    staticClass: "dashLine"
  }, [_c('p', {
    staticClass: "headerT"
  }, [_vm._v("销售信息")])]) : _vm._e(), _vm._v(" "), (_vm.isDianShangBanDan) ? _c('ul', {
    staticClass: "item-content",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('li', [_c('el-form-item', {
    attrs: {
      "label": "销售单号",
      "prop": "saleOrderNo"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "clearable": "",
      "type": "text",
      "maxlength": "30",
      "placeholder": "请输入销售单号"
    },
    model: {
      value: (_vm.orderInfoForm.saleOrderNo),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "saleOrderNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.saleOrderNo"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "商品SKU",
      "prop": "saleGoodsSku"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "clearable": "",
      "type": "text",
      "maxlength": "30",
      "placeholder": "请输入销售商户SKU"
    },
    model: {
      value: (_vm.orderInfoForm.saleGoodsSku),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "saleGoodsSku", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.saleGoodsSku"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "实收金额",
      "prop": "saleActualAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "clearable": "",
      "type": "text",
      "maxlength": "30",
      "placeholder": "请输入实收金额"
    },
    model: {
      value: (_vm.orderInfoForm.saleActualAmount),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "saleActualAmount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.saleActualAmount"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), _c('ul', {
    staticClass: "item1-content"
  }, [_c('li', [_c('el-form-item', {
    attrs: {
      "label": "品牌",
      "prop": "brandId",
      "label-width": "60px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择品牌"
    },
    on: {
      "change": _vm.choseBrand
    },
    model: {
      value: (_vm.orderInfoForm.brandId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "brandId", $$v)
      },
      expression: "orderInfoForm.brandId"
    }
  }, _vm._l((_vm.brandList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    }, [_vm._v(_vm._s(item.brandName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "品类",
      "prop": "categoryId",
      "label-width": "60px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择品类"
    },
    on: {
      "change": _vm.choseCategory
    },
    model: {
      value: (_vm.orderInfoForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "categoryId", $$v)
      },
      expression: "orderInfoForm.categoryId"
    }
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "型号",
      "prop": "modelId",
      "label-width": "60px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择型号"
    },
    on: {
      "change": _vm.choseModel
    },
    model: {
      value: (_vm.orderInfoForm.modelId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "modelId", $$v)
      },
      expression: "orderInfoForm.modelId"
    }
  }, _vm._l((_vm.modelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    }, [_vm._v(_vm._s(item.modelName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "颜色",
      "prop": "colorId",
      "label-width": "60px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择颜色"
    },
    on: {
      "change": _vm.choseColor
    },
    model: {
      value: (_vm.orderInfoForm.colorId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "colorId", $$v)
      },
      expression: "orderInfoForm.colorId"
    }
  }, _vm._l((_vm.colorList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.colorName,
        "value": item.colorId
      }
    }, [_vm._v(_vm._s(item.colorName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "金额",
      "prop": "price"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.price),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "price", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.price"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "部件渠道",
      "prop": "partChannel",
      "label-width": "60px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择部件渠道",
      "clearable": ""
    },
    model: {
      value: (_vm.partChannel),
      callback: function($$v) {
        _vm.partChannel = $$v
      },
      expression: "partChannel"
    }
  }, _vm._l((_vm.partChannelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "fl clearfix",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "故障分类"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.faultTypeCheckList),
      callback: function($$v) {
        _vm.faultTypeCheckList = $$v
      },
      expression: "faultTypeCheckList"
    }
  }, _vm._l((_vm.faultTypeList), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": item.faultTypesId,
        "name": ""
      },
      on: {
        "change": function($event) {
          return _vm.chooseFaultType(item)
        }
      }
    }, [_vm._v(_vm._s(item.faultTypesName))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "fr clearfix",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "故障"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.faultSubCheckList),
      callback: function($$v) {
        _vm.faultSubCheckList = $$v
      },
      expression: "faultSubCheckList"
    }
  }, _vm._l((_vm.faultSubclassList), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": item.faultSubclassId,
        "name": item.faultSubclassId
      },
      on: {
        "change": function($event) {
          return _vm.chooseFaultSubclass(item)
        }
      }
    }, [_vm._v(_vm._s(item.faultSubclassName) + "\n                " + _vm._s(item.price) + "元")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), (_vm.materialList.length > 0) ? _c('div', [_c('p', {
    staticClass: "headerT"
  }, [_vm._v("用料记录")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.materialList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "materialCode",
      "label": "物料编码",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "materialName",
      "label": "物料名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "align": "center",
      "label": "序列号(小码)"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), _c('div', [_c('el-form-item', {
    attrs: {
      "label": "客服备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入给派单客服的备注（不超过400字）",
      "maxlength": 400,
      "type": "text"
    },
    model: {
      value: (_vm.orderInfoForm.handleRemark),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "handleRemark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.handleRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), _c('el-col', {
    staticClass: "headerT"
  }, [(_vm.orderInfoForm != null && null != _vm.orderInfoForm) ? _c('el-button-group', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "20px",
      "width": "100%"
    }
  }, [_vm._l((_vm.orderStates), function(item, index) {
    return _c('el-button', {
      key: index,
      class: {
        activeBtn: _vm.activeBtnIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.changeState(item, index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n            "), (_vm.orderEvents.length !== 0 && index == 1) ? _c('span', [_vm._v("(" + _vm._s(_vm.orderEvents.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.messageList.length !== 0 && index == 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.messageList.length) + ")")]) : _vm._e()])
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-d-caret fr",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.toggleSheet()
      }
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [(_vm.isShow) ? _c('div', {
    staticClass: "clearfix"
  }, [_c('el-row', {
    staticClass: "fl",
    staticStyle: {
      "width": "50%",
      "max-height": "400px",
      "overflow-x": "auto",
      "overflow-y": "auto"
    }
  }, [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.submitMessage),
      expression: "submitMessage"
    }],
    attrs: {
      "customClass": "loadingStyle",
      "element-loading-text": "提交中..."
    }
  }, [(_vm.activeBtnIndex == 0) ? _c('div', {
    staticClass: "box-card-content"
  }, [_c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.messageList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('dl', [_c('dd', [_c('p', [_vm._v("\n                            " + _vm._s(item.operatorTypeName) + "\n                            "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.operatorName))]), _vm._v("\n                            " + _vm._s(_vm._f("date")(item.createTime)) + "\n                          ")]), _vm._v(" "), _c('span', {
      staticClass: "message"
    }, [_vm._v(_vm._s(item.message))]), _vm._v(" "), _c('div', {
      staticClass: "img-content"
    }, _vm._l((item.pictureList), function(item, index) {
      return (item.url) ? _c('img', {
        key: index,
        attrs: {
          "src": item.url,
          "alt": ""
        },
        on: {
          "click": function($event) {
            return _vm.handlePictureCardPreview(item)
          }
        }
      }) : _vm._e()
    }), 0)]), _vm._v(" "), _c('dt', {
      staticStyle: {
        "width": "100px",
        "margin-left": "20px"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOrderMessage(item.id)
        }
      }
    }, [_vm._v("删除回复")])], 1)])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "add-memo-content"
  }, [_c('el-form', {
    ref: "messageForm",
    attrs: {
      "model": _vm.messageForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.messageFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "message"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入回复内容（不超过500字）",
      "maxlength": 500,
      "type": "textarea"
    },
    model: {
      value: (_vm.messageForm.message),
      callback: function($$v) {
        _vm.$set(_vm.messageForm, "message", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "messageForm.message"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "file-list-content clearfix"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    attrs: {
      "list-type": "picture-card",
      "data": _vm.postData,
      "action": "https://up.qiniup.com",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove,
      "limit": 5,
      "on-exceed": _vm.handleExceed,
      "before-remove": _vm.handleBeforeRemove,
      "accept": _vm.acceptImage,
      "auto-upload": false,
      "on-success": _vm.uploadAvatarSuccess,
      "on-error": _vm.uploadAvatarError,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisibles
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibles = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "0 auto",
      "display": "block"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.createEventFormSubmitBtn('messageForm')
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.activeBtnIndex == 1) ? _c('div', [_c('ul', _vm._l((_vm.orderEvents), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "eventLi"
    }, [(item.createTime) ? _c('span', {
      staticClass: "createTime childSpan clearfix"
    }, [_c('i', {
      staticClass: "fl"
    }), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm.formatTime(item.createTime)))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (item.exentContent) ? _c('span', {
      staticClass: "details childSpan"
    }, [_vm._v("\n                        " + _vm._s(item.exentContent) + "\n                        "), _c('br')]) : _vm._e()])
  }), 0)]) : _vm._e()])], 1), _vm._v(" "), (_vm.imageUrls.length > 0) ? _c('el-row', {
    staticClass: "repair-detail-wrapper fr",
    staticStyle: {
      "width": "45%"
    }
  }, [_c('p', {
    staticClass: "headerT"
  }, [_vm._v("维修详情")]), _vm._v(" "), _c('ul', {
    staticClass: "img-repair"
  }, [(_vm.imgBefore.length > 0) ? _c('li', [_vm._l((_vm.imgBefore), function(item, index) {
    return _c('el-image', {
      key: item,
      attrs: {
        "src": item,
        "data-img": _vm.imageUrls,
        "preview-src-list": _vm.imageUrls,
        "alt": ""
      }
    })
  }), _vm._v(" "), _c('p', [_vm._v("维修前")])], 2) : _vm._e(), _vm._v(" "), (_vm.threeImg.length > 0) ? _c('li', [_vm._l((_vm.threeImg), function(item, index) {
    return _c('el-image', {
      key: item,
      attrs: {
        "src": item,
        "data-img": _vm.imageUrls,
        "preview-src-list": _vm.imageUrls,
        "alt": ""
      }
    })
  }), _vm._v(" "), _c('p', [_vm._v("三联单")])], 2) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "after-repair clearfix"
  }, _vm._l((_vm.imgAfter), function(item, index) {
    return (_vm.imgAfter.length > 0) ? _c('li', {
      key: index,
      staticClass: "fl"
    }, [_c('el-image', {
      attrs: {
        "src": item,
        "data-img": _vm.imageUrls,
        "preview-src-list": _vm.imageUrls,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v("维修后")])], 1) : _vm._e()
  }), 0)]) : _vm._e()], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), _c('p', {
    staticClass: "headerT"
  }, [_vm._v("支付信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "IMEI",
      "label-width": "80px",
      "prop": "imei"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.imei),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "imei", $$v)
      },
      expression: "orderInfoForm.imei"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "定金(元)",
      "prop": "price"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "oninput": "this.value=this.value.replace(/\\D/g,'').replace(/^0{1,}/g,'')",
      "clearable": "",
      "placeholder": "请输入金额",
      "maxlength": "4"
    },
    model: {
      value: (_vm.orderInfoForm.earnest),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "earnest", $$v)
      },
      expression: "orderInfoForm.earnest"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合计金额",
      "prop": "amountPayable"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.amountPayable),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "amountPayable", $$v)
      },
      expression: "orderInfoForm.amountPayable"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-switch', {
    staticStyle: {
      "display": "block",
      "margin-top": "10px"
    },
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-text": "收款",
      "inactive-text": "不收款",
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.orderInfoForm.payFlag),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "payFlag", $$v)
      },
      expression: "orderInfoForm.payFlag"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实付金额",
      "prop": "actualPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.actualPrice),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "actualPrice", $$v)
      },
      expression: "orderInfoForm.actualPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "服务SKU",
      "prop": "price"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.sku),
      callback: function($$v) {
        _vm.sku = $$v
      },
      expression: "sku"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "支付状态",
      "prop": "price"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "value": _vm._f("sysCodeFileter")(_vm.orderInfoForm.payStatus, 'pay_status')
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "支付方式"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择支付方式"
    },
    model: {
      value: (_vm.orderInfoForm.paymentId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "paymentId", $$v)
      },
      expression: "orderInfoForm.paymentId"
    }
  }, _vm._l((_vm.payWay), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "selected": {
          'selected': item.type == _vm.orderInfoForm.paymentId
        },
        "label": item.content,
        "value": item.type
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收钱吧号",
      "prop": "takeTheMoney"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.takeTheMoney),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "takeTheMoney", $$v)
      },
      expression: "orderInfoForm.takeTheMoney"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin": "30px 0 20px"
    },
    attrs: {
      "span": 6
    }
  }, [(_vm.orderInfoForm.adminStatus == '15' || _vm.orderInfoForm.adminStatus == '20' || _vm.orderInfoForm.adminStatus == '16') ? _c('div', [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.closeBack()
      }
    }
  }, [_vm._v("返回")])], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.adminStatus == '03' || _vm.orderInfoForm.adminStatus == '05' || _vm.orderInfoForm.adminStatus == '06' || _vm.orderInfoForm.adminStatus == '07' || _vm.orderInfoForm.adminStatus == '12' || _vm.orderInfoForm.adminStatus == '32' || _vm.orderInfoForm.adminStatus == '41' || _vm.orderInfoForm.adminStatus == '42' || _vm.orderInfoForm.adminStatus == '43' || _vm.orderInfoForm.adminStatus == '44') ? _c('div', [(_vm.basicsAuth.cancel_order) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.change_order_info) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateOrder('orderInfoForm')
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.tianxuan_order) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.jhhToM3Esure()
      }
    }
  }, [_vm._v("转单M4")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.closeBack()
      }
    }
  }, [_vm._v("返回")])], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.adminStatus == '09' || _vm.orderInfoForm.adminStatus == '13' || _vm.orderInfoForm.adminStatus == '36' || _vm.orderInfoForm.adminStatus == '17' || _vm.orderInfoForm.adminStatus == '10' || _vm.orderInfoForm.adminStatus == '14' || _vm.orderInfoForm.adminStatus == '33' || _vm.orderInfoForm.adminStatus == '37' || _vm.orderInfoForm.adminStatus == '11' || _vm.orderInfoForm.adminStatus == '34' || _vm.orderInfoForm.adminStatus == '38' || _vm.orderInfoForm.adminStatus == '08' || _vm.orderInfoForm.adminStatus == '31' || _vm.orderInfoForm.adminStatus == '35' || _vm.orderInfoForm.adminStatus == '39' || _vm.orderInfoForm.adminStatus == '40') ? _c('div', [(_vm.basicsAuth.change_order_info) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateOrder('orderInfoForm')
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.tianxuan_order) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.jhhToM3Esure()
      }
    }
  }, [_vm._v("转单M4")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.closeBack()
      }
    }
  }, [_vm._v("返回")])], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.adminStatus == '02') ? _c('div', [(_vm.basicsAuth.change_order_info) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateOrder('orderInfoForm')
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.tianxuan_order) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.jhhToM3Esure()
      }
    }
  }, [_vm._v("转单M4")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.ensure_order) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ensure()
      }
    }
  }, [_vm._v("确认订单")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.cancel_order) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.closeBack()
      }
    }
  }, [_vm._v("返回")])], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.adminStatus == '30' || _vm.orderInfoForm.adminStatus == '01') ? _c('div', [(_vm.basicsAuth.change_order_info) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateOrder('orderInfoForm')
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.ensure_order) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ensure()
      }
    }
  }, [_vm._v("确认订单")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.unable_to_ensure) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.notEnsure()
      }
    }
  }, [_vm._v("无法确认")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.cancel_order) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.closeBack()
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.basicsAuth.tianxuan_order) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.jhhToM3Esure()
      }
    }
  }, [_vm._v("转单M4")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.adminStatus == '04') ? _c('div', [(_vm.basicsAuth.change_order_info) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateOrder('orderInfoForm')
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.reject) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rejectFuc()
      }
    }
  }, [_vm._v("驳回订单")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.reassignment) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.reassignmentFuc()
      }
    }
  }, [_vm._v("改派")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.cancel_order) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.closeBack()
      }
    }
  }, [_vm._v("返回")])], 1) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请选择送机方式",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "送机方式",
      "disabled": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择送机方式"
    },
    model: {
      value: (_vm.sendMachineWay),
      callback: function($$v) {
        _vm.sendMachineWay = $$v
      },
      expression: "sendMachineWay"
    }
  }, _vm._l((_vm.sendMachineWayList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.sendMachineWay != null && _vm.sendMachineWay != '') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.maintenancePendingOpe()
      }
    }
  }, [_vm._v("确\n        定")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "取消原因",
      "visible": _vm.dialogCancelFormVisible,
      "width": "400px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCancelFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "cancelForm",
    attrs: {
      "model": _vm.cancelForm,
      "rules": _vm.cancelFormRules,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticClass: "select-content",
    attrs: {
      "prop": "cancelReason",
      "label": "取消原因",
      "label-width": "80px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择取消原因"
    },
    model: {
      value: (_vm.cancelForm.cancelReason),
      callback: function($$v) {
        _vm.$set(_vm.cancelForm, "cancelReason", $$v)
      },
      expression: "cancelForm.cancelReason"
    }
  }, _vm._l((_vm.cancelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其他补充",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入取消原因(不超过500字)",
      "maxlength": "500",
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.cancelForm.cancelDesc),
      callback: function($$v) {
        _vm.$set(_vm.cancelForm, "cancelDesc", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "cancelForm.cancelDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.emptyCancelConfirm
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelConfirmBtn('cancelForm')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogUnConfirmFormVisible,
      "width": "400px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogUnConfirmFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "unConfirmForm",
    attrs: {
      "model": _vm.unConfirmForm,
      "rules": _vm.unConfirmFormRules,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原因",
      "label-width": "50px",
      "prop": "cannotConfirmDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入无法确认原因(不超过500字)",
      "maxlength": "500",
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.unConfirmForm.cannotConfirmDesc),
      callback: function($$v) {
        _vm.$set(_vm.unConfirmForm, "cannotConfirmDesc", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "unConfirmForm.cannotConfirmDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.emptyUnConfirm
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.unConfirmBtn('unConfirmForm')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-b4a8020c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/workOrder/visitRepair.vue
// module id = 1736
// module chunks = 0